// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - PAGES ||============================== //

export async function handlePages(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest(`/developments/${action.id}/pages`);
    default:
      console.info('[ApiManager > handleApiAction > handlePages] - Unknown method');
      break;
  }
}
